import React from 'react';
import { useTranslation } from 'react-i18next';
import { PiGlobeLight, PiUsersLight } from 'react-icons/pi';
import Toggle from '../TailwindComponents/Toggle';
import { Well } from '../brand/Field';

interface OrgWideToggleProps {
  id?: string;
  name?: string;
  label?: string;
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  /** Override the main label text */
  title?: string;
  /** Override the description when off */
  offDescription?: string;
  /** Override the description when on */
  onDescription?: string;
  /** Override the helper text when on */
  onHelperText?: string;
}

const OrgWideToggle: React.FC<OrgWideToggleProps> = ({
  value,
  onChange,
  disabled,
  title,
  offDescription,
  onDescription,
  onHelperText,
}) => {
  const { t } = useTranslation();

  const displayTitle = title || t('Organization-wide');
  const displayOffDesc = offDescription || t('Enable to share with everyone in your organization.');
  const displayOnDesc = onDescription || t('All members of your organization will have view access. You will remain the admin.');
  const displayOnHelper = onHelperText || t('All organization members will be added as viewers');

  return (
    <Well className="flex items-start gap-4 p-4">
      <div className="flex-shrink-0 mt-0.5">
        <Toggle
          enabled={value}
          onToggle={onChange}
          disabled={disabled}
          ariaLabel={displayTitle}
        />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <PiGlobeLight className="w-4 h-4 text-fg-muted" />
          <span className="text-sm font-medium text-fg-strong">
            {displayTitle}
          </span>
        </div>
        <p className="text-xs text-fg-muted mt-1">
          {value ? displayOnDesc : displayOffDesc}
        </p>
        {value && (
          <div className="flex items-center gap-1.5 mt-2 text-xs text-fg-muted">
            <PiUsersLight className="w-3.5 h-3.5" />
            <span>{displayOnHelper}</span>
          </div>
        )}
      </div>
    </Well>
  );
};

export default OrgWideToggle;
